module.exports = __webpack_public_path__ + "static/ICONFOOTER-11-90b7a7cc395e73641d5b6e413e27913b.png";